module.exports = __webpack_public_path__ + "img/view_device_c4_en.99d03ee4.png";